import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "components/app/dialog/dialog";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, X } from "lucide-react";

import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
interface DialogProps {
  isDailogSendReport: boolean;
  setIsDailogSendReport: (value: boolean) => void;
  selectedProductIds: any;
}
export default function DailogSendReport({ isDailogSendReport, setIsDailogSendReport, selectedProductIds }: DialogProps) {
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const { showDialogMessage } = appStore();

  const [loadingSubmitSendReport, setLoadingSubmitSendReport] = useState<boolean>(false);

  const submitSendMonthlyReport = async () => {
    setLoadingSubmitSendReport(true);
    try {
      const url = `${RouteApi.submitSendMonthlyReport}token=${token}`;
      const data = {
        shop_id: shopId,
        ids: selectedProductIds,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setIsDailogSendReport(false);
        setLoadingSubmitSendReport(false);
        showDialogMessage({
          title: response.status,
          message: response.msg,
          barrierDismissible: true,
          status: response.status,
        });
      } else {
        showDialogMessage({
          title: response.status,
          message: response.msg,
          barrierDismissible: false,
        });

        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[submitSendMonthlyReport]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  return (
    <>
      <Dialog open={isDailogSendReport}>
        <DialogContent isShowBtnXClose={false} className=" max-w-[860px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 ">
          <DialogHeader>
            <DialogTitle>Send Report</DialogTitle>
            <DialogDescription>Send detail attendance report.</DialogDescription>
            <div
              className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
              onClick={() => setIsDailogSendReport(false)}
            >
              <X />
            </div>
          </DialogHeader>

          <ScrollArea className="mt-2 gap-3 overflow-hidden "></ScrollArea>
          <ScrollBar orientation="vertical" />
          <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
            <button
              onClick={() => {
                submitSendMonthlyReport();
              }}
              className=" outline-none focus:border-none w-full mt-6 flex items-center justify-center  bg-blue-500 text-white text-lg py-2 rounded-lg"
            >
              {loadingSubmitSendReport ? <Loader className="animate-spin" /> : "Submit"}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
